import { Task, TaskStartDatePeriod } from "Models/task";

export function getDefaultTaskValue() {
  const defaultTask: Partial<Task> = {
    name: "",
    startDate: undefined,
    endDate: undefined,
    description: "",
    period: TaskStartDatePeriod.MORNING,
    members: [],
    fleets: [],
  };

  return defaultTask;
}
